export enum TripType {
  Corporate = 'Corporate',
  Personal = 'Personal',
  PrivateTaxable = 'Private Taxable',
  PrivateOccasional = 'Private Occasional',
}

export const TripTypeIds: Record<number, TripType> = {
  1: TripType.Corporate,
  2: TripType.Personal,
  3: TripType.PrivateTaxable,
  4: TripType.PrivateOccasional,
};
